import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *签到
 * @param activityId
 * 
*/

export const sign = activityId => Http.post(`${baseUrl}/activity/sign/${activityId}` )

/**
 *签到信息
 * @param activityId 
 * 
*/

export const signInfo = activityId => Http.get(`${baseUrl}/activity/sign/${activityId}/info` )

